var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"vdpr-datepicker__switch"},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.checked},on:{"click":_vm.onClick}}),_c('span',{staticClass:"vdpr-datepicker__switch-slider"})])
}
var staticRenderFns = []

export { render, staticRenderFns }